import { observable } from 'mobx';
import { CountUp } from 'countup.js';
import { delay } from '@src/utils/common-util';
import DownLoadModalStore from '@src/business-components/modals/download/store';
import DownloadModal from '@src/business-components/modals/download';
import useModal from '@src/utils/hooks/use-modal';
import useMount from '@src/utils/hooks/use-mount';
import { useLayerData } from '@src/utils/hooks/use-layer-data';
import { useEffect, useRef } from 'react';
import Video from '@src/components/video';
import AppointmentModal from '../appointment-modal';

import AppointmentSuccessModal from '@src/business-components/appointment-success-modal';

import GiftModal from '../gift-modal';
import GiftModalStore from '../gift-modal/store';
import copy from '../../../../components/copy';
import Toast from '@src/business-components/common-message';
import getPageLocalesData from '@src/global-locales/get-page-locales-data';
import { $$tracker } from '@src/tracker';
import { autobind } from 'core-decorators';
import { useRequest } from 'ahooks';
import Service from './service';
import GiftPackModalStore from '@src/business-components/giftPack-modal/store';
import GiftPackModal from '@src/business-components/giftPack-modal';
import getLanguageByPath from '@src/utils/locale/getLanguageByPath';

const pageLocalesData = getPageLocalesData();
const mainLocalesData = pageLocalesData.main;
const lang = getLanguageByPath();

class kvPageStore {
  // 是否激活
  @observable isActive = false;
  /**
   * 当前预约总数
   * @type {*}
   */
  @observable appointmentTotal = 0;
  //page1数据集合
  @observable page1Data;
  @observable huodong1;
  constructor(props = {}) {
    Object.assign(this, { ...props });
  }

  /**
   * 抢购时间范围
   * @type {{end: *, begin: *}}
   */
  @observable
  timeRange = {
    begin: undefined, // 开始时间
    end: undefined // 结束时间
  };
  //活动数据集合
  @observable activityList = [];

  /**
   * 售卖状态
   * @type {number} 0-未开始 1-正在售卖 2-售卖结束
   */
  @observable sellStatus = undefined;
  /**
   * 当前时间
   * @type {*}
   */
  @observable currentTime = undefined;

  // 视频播放
  @observable videoPlayState = false;

  /**
   *  预约状态/下载状态  1下载 0预约
   */
  @observable is_in_open_download_time;
  /**
   *  登录邮箱/seasun账号（open_down_load为1是seasun账号，为0是登录邮箱号）
   */
  @observable account;
  /**
   *  是否在预约发码阶段（1：是，0：否）用来判断预约阶段公测礼包是否展示
   */
  @observable is_in_subscribe_code_time;
  /**
   * 下载阶段是否开启福利码发放（1：是，0：否）
   */
  @observable is_game_open_get_code_status;

  // 复制PC端链接
  @observable PC_URL = `https://mechabreak.seasungames.com/p/zt/2025/03/21/market/${lang}/index.html#/`;

  /**
   *  下载弹窗
   */
  downLoadModalStore = new DownLoadModalStore();
  /**
   *  典藏礼包弹窗
   */
  giftModalStore = new GiftModalStore();
  /**
   *  公测礼包弹窗
   */
  giftPackModalStore = new GiftPackModalStore({
    openLogin: () => {
      if (this.is_in_open_download_time === 0) {
        this.appointmentModalStore.isGiftOpen = false;
        this.appointmentModal.open();
      } else {
        // 海外通行证
        window.XPASS.signin();
      }
    }
  });

  // 通用活动的方法
  activityClick(is_only_pc, url) {
    if (is_only_pc === '1') {
      copy(url, { successPreText: `${mainLocalesData.giftPackCopyText}` });
    }
  }

  // 下载按钮
  download() {
    $$tracker.clickHomeDownload();
    this.downloadModal.open();
  }

  // 公测礼包
  openGiftPach() {
    this.giftPackModalStore.isOpen = true;
    this.giftPackModal.open();
  }

  // 典藏礼包
  gift() {
    // if (this.observable === 1) {
    this.giftModalStore.isOpen = true;
    this.giftModal.open();
    // } else {
    //   copy(this.PC_URL, { successPreText: mainLocalesData.giftPackCopyText });
    // }
    // $$tracker.clickHomeCB();
  }

  openVideo() {
    if (this.isVideoLink(this.page1Data?.video_link)) {
      this.videoPlayState = true;
      Video.append({
        src: this.page1Data?.video_link,
        onCloseCallback: () => {
          this.videoPlayState = false;
        }
      });
    } else {
      Toast.info(`${pageLocalesData.global.comming_soon}`);
    }
  }
  isVideoLink(url) {
    const videoExtensions = ['mp4', 'webm', 'ogg', 'mov', 'avi', 'flv', 'wmv', 'mkv'];
    const extension = url
      .split('.')
      .pop()
      .toLowerCase();
    return videoExtensions.includes(extension);
  }

  // // 典藏礼包-获取配置
  // @autobind
  // async init() {
  //   try {
  //     const res = await this.getConfigRequest.run();
  //     this.currentTime = res.reply.current_time;
  //     this.timeRange.begin = res.reply.limited_edition_purchase_range_time.begin;
  //     this.timeRange.end = res.reply.limited_edition_purchase_range_time.end;
  //   } catch (err) {
  //     console.log('err:', err);
  //   }
  // }

  /**
   * 初始化预约数字
   */
  @autobind
  async initValue() {
    if (this.numberRef.current) {
      const countCountUp = new CountUp(this.numberRef.current, this.appointmentTotal, {
        startVal: 0,
        duration: 5,
        separator: ','
      });
      await delay(800);
      countCountUp.start();
    }
  }
  // 典藏礼包
  clickGiftPack() {
    copy(this.PC_URL, { successPreText: `${pageLocalesData.main.giftPackCopyText}` });
  }

  use() {
    const kvPartDate = useLayerData('kvPageData');

    // 获取公测礼包配置
    // this.gwConfigRequest = useRequest(async () => await Service.gwConfig(), {
    //   manual: true,
    //   onSuccess: res => {
    //     this.appointmentTotal = res.total;
    //     // 是否开启游戏下载（1：是，0：否）
    //     this.is_in_open_download_time = res?.is_in_open_download_time;
    //     // 预约态/登录态
    //     this.account = res?.account;
    //     // 是否在预约发码阶段（1：是，0：否）
    //     this.is_in_subscribe_code_time = res?.is_in_subscribe_code_time;
    //     //下载阶段是否开启福利码发放（1：是，0：否）
    //     this.is_game_open_get_code_status = res?.is_game_open_get_code_status;

    //     if (res?.account) {
    //       if (res?.account || window.XPASS.$accountStore.loginStatus) {
    //         if (res?.is_in_open_download_time === 0 && res?.is_in_subscribe_code_time === 1) {
    //           this.getAppointmentCodeRequest.run();
    //         } else if (res?.is_in_open_download_time === 1 && res?.is_game_open_get_code_status === 1) {
    //           this.getDownLoadCodeRequest.run();
    //         }
    //       }
    //     }
    //   },
    //   onError: err => {
    //     // console.log('err:', err);
    //   }
    // });

    // 获取典藏礼包配置
    // this.getConfigRequest = useRequest(async () => await Service.getConfig(), {
    //   manual: true
    // });
    // 获取预约福利码
    this.getAppointmentCodeRequest = useRequest(async () => await Service.getAppointmentCode(), {
      manual: true,
      onSuccess: res => {
        this.giftPackModalStore.giftCdk = res?.code;
      },
      onError: err => {
        const { code, msg } = err.serviceResponse;
        if (msg) {
          Toast.info(msg);
        }
      }
    });
    // 获取下载福利码
    this.getDownLoadCodeRequest = useRequest(async () => await Service.getDownLoadCode(), {
      manual: true,
      onSuccess: res => {
        this.giftPackModalStore.giftCdk = res?.code;
      },
      onError: err => {
        const { code, msg } = err.serviceResponse;
        if (msg) {
          Toast.info(msg);
        }
      }
    });

    useEffect(
      () => {
        if (!kvPartDate) {
          return;
        }
        this.page1Data = kvPartDate;
        this.activityList = kvPartDate.activity_list || [];
      },
      [kvPartDate]
    );

    // 下载弹窗
    this.downloadModal = useModal(DownloadModal, {
      store: this.downloadModalStore
    });
    // 典藏礼包弹窗
    this.giftModal = useModal(GiftModal, {
      store: this.giftModalStore
    });
    // 公测礼包弹窗
    this.giftPackModal = useModal(GiftPackModal, {
      store: this.giftPackModalStore
    });
    // 预约弹窗
    this.appointmentModal = useModal(AppointmentModal, {
      store: this.appointmentModalStore
    });
    // 预约成功弹窗
    this.appointmentSuccessModal = useModal(AppointmentSuccessModal, {
      store: this.appointmentSuccessModalStore
    });

    useEffect(
      () => {
        if (window.XPASS.$accountStore.loginStatus) {
          // this.gwConfigRequest.run();

          return () => {
            // 卸载
          };
        }
      },
      [window.XPASS.$accountStore.loginStatus]
    );

    useMount(() => {
      // this.gwConfigRequest.run();
      // this.giftPackModalStore.isReceive = true;
      // this.giftPackModalStore.isOpen = true;
      // this.giftPackModal.open();
    });
    this.numberRef = useRef(null);
    useEffect(
      () => {
        if (this.appointmentTotal && this.numberRef.current) {
          this.initValue();
        }
      },
      [this.appointmentTotal, this.numberRef.current]
    );

    // useEffect(
    //   () => {
    //     if (this.currentTime < this.timeRange.begin) {
    //       this.sellStatus = 0;
    //     } else if (this.currentTime > this.timeRange.begin && this.currentTime < this.timeRange.end) {
    //       this.sellStatus = 1;
    //     } else if (this.currentTime >= this.timeRange.end) {
    //       this.sellStatus = 2;
    //     } else {
    //     }
    //   },
    //   [this.timeRange.begin, this.timeRange.end, this.currentTime]
    // );
  }
}

export default kvPageStore;
